import { motion } from "framer-motion";

const PORTRAIT =
  "https://customer-assets-jai6qajn.emergentagent.net/job_12aad205-13aa-44c9-9af3-4780b06fb648/artifacts/uzcb6dxt_Adonica%20Book%20Shoot-5.webp";

const credentials = [
  { label: "DONA-Trained Doula", testid: "credential-badge-dona" },
  { label: "ICEA-Trained Childbirth Educator (CBE)", testid: "credential-badge-educator" },
  { label: "Intl Health Coach (INHC/CIHC)", testid: "credential-badge-iin" },
];

const BioSection = () => (
  <section
    id="about"
    data-testid="bio-section"
    className="py-20 lg:py-28 overflow-hidden"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
      <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.92 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
          className="relative flex justify-center"
        >
          <div className="absolute -inset-5 rounded-full border-2 border-[#F2644C]/50 rotate-2" />
          <div className="absolute -inset-11 rounded-full border-2 border-[#F5B301]/30 -rotate-1" />
          <motion.img
            data-testid="founder-portrait-image"
            src={PORTRAIT}
            alt="Adonica Shaw, founder of Tri Valley Community Doula Services"
            whileHover={{ scale: 1.03 }}
            transition={{ type: "spring", stiffness: 180, damping: 20 }}
            className="relative grayscale rounded-full aspect-square object-cover object-top border-4 border-[#2B1B45] shadow-2xl w-64 h-64 sm:w-80 sm:h-80"
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1], delay: 0.15 }}
        >
          <p className="text-xs uppercase tracking-[0.25em] font-heading font-bold text-[#F2644C] mb-4">
            Meet Founder Adonica Shaw
          </p>
          <h2
            data-testid="founder-name-text"
            className="font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-[#2B1B45] mb-3"
          >
            Adonica Shaw{" "}
            <span className="text-lg sm:text-xl lg:text-2xl font-bold tracking-normal text-[#7A7390]">
              CBE, INHC, CIHC
            </span>
          </h2>
          <p className="font-serif italic text-lg sm:text-xl text-[#6D28D9] mb-6">
            Championing community maternal wellness
          </p>
          <p
            data-testid="founder-bio-text"
            className="text-base sm:text-lg text-[#5B5470] leading-relaxed mb-8"
          >
            Adonica Shaw is a DONA-trained doula, an ICEA-trained Childbirth
            Educator (CBE), and Certified International Health Coach (INHC,
            CIHC). Dedicated to
            eliminating disparities in maternal care, Adonica provides
            compassionate, evidence-based support to growing families
            throughout San Joaquin County.
          </p>
          <div className="flex flex-wrap gap-2.5">
            {credentials.map((c, i) => (
              <motion.span
                key={c.testid}
                data-testid={c.testid}
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.25 + i * 0.07, duration: 0.5 }}
                className="text-xs font-heading font-bold uppercase tracking-wider px-4 py-2 rounded-full bg-white border-2 border-[#2B1B45] text-[#2B1B45] hover:bg-[#2B1B45] hover:text-white transition-colors duration-300 cursor-default"
              >
                {c.label}
              </motion.span>
            ))}
          </div>
        </motion.div>
      </div>
    </div>
  </section>
);

export default BioSection;
